import Utils from '../utils';

export default {
    install(Vue) {
        Vue.filter('resourceUrl', (path) => Utils.file.getResourceUrl(path));
        Vue.filter('mobile', (mobile) => Utils.string.maskMobile(mobile));
    },
};
